// Rotas na raiz da API, fora do /admin que já está na baseURL do client.
export const CustomerRegistrationEndpoints = {
  find: (token: string) => `/public/customer-registration/${token}`,
  confirm: (token: string) => `/public/customer-registration/${token}/confirm`,
};
